import { render, staticRenderFns } from "./CommissionsGroups.vue?vue&type=template&id=bfd13a8a&scoped=true"
import script from "./CommissionsGroups.vue?vue&type=script&lang=ts"
export * from "./CommissionsGroups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd13a8a",
  null
  
)

export default component.exports